import { pathOr } from 'ramda'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators, Dispatch } from 'redux'

import { MIC_ACCESS_ERROR } from '@/app/definitions'
import { selectToken } from '@/app/module/auth/store/selectors'
import { getCustomFields } from '@/app/module/custom-fields/store/actions'
import { selectPersonalizationList } from '@/app/module/logs/store/selectors'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId, selectUserId, selectUserTimezone } from '@/app/module/user/store/selectors'
import { selectCountriesTimezones, selectDefaultCountryCode } from '@/app/module/utils/store/selectors'
import { AppState } from '@/app/types/store'

import PhoneNumbers from './component'
import Item from './component/item'
import { getPhonenumbersFile, onError, savePhonenumbersFile } from './store/actions'
import { selectPhoneNumberFilesState } from './store/phone-number-files.slice'

export default PhoneNumbers

const itemSelector = ({ customFields, phoneNumberFiles, user, utils }: AppState) => ({
  hydrateProps: ['token', 'orgId', 'phoneNumberId'],
  token: selectToken(),
  orgId: selectOrgId({ user }),
  personalizationList: selectPersonalizationList({ customFields }),
  userId: selectUserId({ user }),
  files: selectPhoneNumberFilesState({ phoneNumberFiles }),
  timezone: selectUserTimezone({ user, utils }),
  timezones: pathOr({}, ['countriesTimezonesList', 'data'], utils),
  countriesTimezones: selectCountriesTimezones({ utils }),
  countryCode: selectDefaultCountryCode({ utils }),
})

const itemDispatcher = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      hydrate:
        ({ token, orgId }) =>
        () =>
          Promise.all([dispatch(getCustomFields({ token, orgId }))]),
      getFile: getPhonenumbersFile,
      onError,
      onMicAccessError: () =>
        dispatch(
          createNotification({
            'mic-access': {
              type: 'error',
              message: MIC_ACCESS_ERROR,
            },
          }),
        ),
      saveFile: savePhonenumbersFile,
    },
    dispatch,
  )

export const PhoneNumberItem = connect(itemSelector, itemDispatcher)(withRouter(Item))
